import COLOR from "../../constants/colors";

const styles = {
  paleBackground: {
    background: COLOR.white,
  },
  greenBackground: {
    background: COLOR.green,
  },
  mainArea: {
    marginTop: 64,
    marginLeft: 0,
    minWidth: "180vh",
    background: COLOR.greenSmoke,
    minHeight: "100vh",
  },
};

export default styles;
